import type { FaireProductEntity } from "../../entity_types/product";

export const p_96uh69v26n: FaireProductEntity = {
  token: "p_96uh69v26n",
  type: "product",
  name: "PAIR OF 316L SS HUGGIE/HOOP EARRINGS WITH STAR DANGLE",
  brandToken: "b_punhnqvhh6",
  brandName: "CRAVE",
  imageUrl:
    "https://cdn.faire.com/fastly/e40ea84f06b68dbd6f9acf0bcf7079a088396f6c887039b7a5c6ac99face9d57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4292eca4187e5213421f21a892859a4634f2e7f92f0f4aeb29b4bc580e5633e3.jpeg",
    "https://cdn.faire.com/fastly/b963661938565d5473bd7398c67638bcfaadef34d740a9ffd3da3e3869f5643b.jpeg",
    "https://cdn.faire.com/fastly/172890ab8dfa52e4cd1b02006879864e11f3741bea2f78f1b05b5c021112ce86.jpeg",
  ],
  priceDollars: 1.15,
  description:
    "PAIR OF 316L STAINLESS STEEL HUGGIE/HOOP EARRINGS WITH STAR DANGLE\nThickness: 4MM\nLength: 9MM\nMaterial: 316L Stainless Steel",
  tags: [],
  msrpDollars: 2.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:56.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
